<template>
<div class="container-fluid d-flex flex-column h-100" v-if="$store.state.data.info.bibles.length">
  <div class="bible-open-head">
    <b-button class="invisible">
      dummy
    </b-button>
  </div>
  <div class="row no-gutters bible-open-body h-100">
    <b-card no-body class="w-100 h-100">
      <div class="row btn-group btn-group-tile btn-group-tile-3">
        <b-button variant="light"
          v-for="(item, index) in $store.state.data.info.bibles"
          class="text-center col-12"
          @click="onClickBible($event, item)"
          >
          {{ item.name }}
        </b-button>
      </div>
    </b-card>
  </div>
</div>
</template>

<script>
module.exports = {
  data: function () {
    return {
    }
  },

  computed: {
    ui: {
      get () { return this.$store.state.ui },
      set (value) {},
    },
  },

  methods: {
    onShown(event) {
    },

    onClickBible(event, item) {
      this.$store.dispatch('dataBibleOpenWithIndex', {
        bible: item.code,
        book: 'GEN',
        chapter: 0,
        verse: 0,
        pushHistory: true,
      })
      this.$store.dispatch('uiToggleModalBibleOpen', false)
    },
  },
}
</script>

<style lang="scss">
.bible-open-body {
  .tabs {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;

    .card-header {
      .nav-tabs {
        display: flex;

        li.nav-item {
          flex-grow: 1;

          a.nav-link {
            text-align: center;

            &.active {
              border-color: #dee2e6;
            }
          }
        }
      }
    }

    .tab-content {
      flex-grow: 1;
      overflow-y: scroll;

      .tab-pane {
        .row {
          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }
          
          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }
        }
      }
    }
  }
}
</style>
